import microuniversoApi from "app/api/microuniversoApi";
import { renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { useAppSelector } from "app/redux/hooks";
import { ICliente } from "app/types/ICliente";
import { IEndereco } from "app/types/IEndereco";
import { Parametro } from "app/types/Parametro";
import { Permissao } from "app/types/Permissao";
import { tratamentoErroPadrao } from "app/use-cases";
import { obterPermissao } from "app/use-cases/obterPermissao";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import { FormikErrors } from "formik";
import globalMU from "globalMU";
import * as R from "ramda";
import React, { useEffect, useState } from "react";
import { Abas } from "../../abas/Abas";
import { Breadcrumb2Container } from "../../breadcrumb2/Breadcrumb2Container";
import { AbaEnderecosContainer } from "../aba-enderecos/AbaEnderecosClienteContainer";
import { AbasPesquisaClienteContainer } from "../AbasPesquisaClienteContainer";
import { NovoEnderecoClienteContainer } from "../aba-enderecos/novo-endereco/NovoEnderecoClienteContainer";
import { PesquisarClienteContainer } from "../PesquisarClienteContainer";
import { DadosBasicosClienteNaoCadastradoContainer } from "./DadosBasicosClienteNaoCadastradoContainer";
import { v4 as uuidv4 } from 'uuid';
import { removerClienteOrcamento } from "app/use-cases/orcamento/cliente/removerClienteOrcamento";
import store from "app/redux/store/store";
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";

const estilosBotoes = require("../../../estilos/botoes.module.scss").default;

type NomesAbas = "Dados Básicos" | "Endereços";

export type AbasPesquisaClienteNaoCadastradoContainerProps = {
  abaSelecionada?: "Dados Básicos" | "Endereços";
  regiaoRenderizada: string
};

export const AbasPesquisaClienteNaoCadastradoContainer = (props: AbasPesquisaClienteNaoCadastradoContainerProps) => {
  const orcamento = useAppSelector((store) => store.orcamento);
  const identificadorOrcamento = orcamento.IdentificadorOrcamento;

  const [abaSelecionada, setAbaSelecionada] = useState<NomesAbas>(props.abaSelecionada ?? "Dados Básicos");

  const [cliente, setCliente] = useState<ICliente>();

  const [validarDadosBasicos, setValidarDadosBasicos] = useState(false);
  const [formulariovalidado, setFormularioValidado] = useState(false);
  const [errosFormulario, setErrosFormulario] = useState<FormikErrors<ICliente>>();

  const [exibirCadastrarCliente, setExibirCadastrarCliente] = useState<boolean>(false);
  const [exibeIncluirEndereco, setExibeIncluirEndereco] = useState(false);

  const [enderecoAEditar, setEnderecoAEditar] = useState<IEndereco>();
  const [enderecosTemporarios, setEnderecosTemporarios] = useState<IEndereco[]>()
  const [enderecosSelecionados, setEnderecosSelecionados] = useState<IEndereco[]>([]);

  const [parametros, setParametros] = useState<Parametro[]>([])
  const [permissoes, setPermissoes] = useState<Permissao[]>([])

  const atualizarParametros = async () => {
    setParametros(
      await obterParametros({
        nomes: [
          "BAIRRO_NUMERO_OPCIONAL_CADASTRO_CLIENTE",
          "UTILIZAR_BAIRROS_PRE_CADASTRADOS"
        ],
      })
    );
  };

  const atualizarPermissoes = async () => {
    setPermissoes([
      {
        Acao: "ALTERAR",
        Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE_NAO_CADASTRADO", acao: "ALTERAR" })
      },
      {
        Acao: "ENDERECO_CLIENTE_NAO_CADASTRADO_ALTERAR",
        Permitido: await obterPermissao({ funcionalidade: "SEGURANCA_EDITAR_USUARIO", acao: "ENDERECO_CLIENTE_NAO_CADASTRADO_ALTERAR" })
      },
      {
        Acao: "INCLUIR",
        Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE_NAO_CADASTRADO", acao: "INCLUIR" })
      },
      {
        Acao: "ENDERECO_CLIENTE_NAO_CADASTRADO_INCLUIR",
        Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE_NAO_CADASTRADO", acao: "ENDERECO_CLIENTE_NAO_CADASTRADO_INCLUIR" })
      },
      {
        Acao: "ENDERECO_CLIENTE_NAO_CADASTRADO_EXCLUIR",
        Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE_NAO_CADASTRADO", acao: "ENDERECO_CLIENTE_NAO_CADASTRADO_EXCLUIR" })
      }
    ])
  }

  const valorParametro = (nome: string) => parametros.find(p => p.Nome == nome)?.Valor

  const valorPermissaoPorAcao = (nome: string) => permissoes.find(p => p.Acao == nome)?.Permitido

  const cadastroClienteNaoCadastrado = async () => {
    try {
      globalMU.blockUI();
      const dadosPesquisados = await microuniversoApi.Cliente.cadastroClienteNaoCadastrado(
        identificadorOrcamento
      );
      setCliente(dadosPesquisados);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const onToggleEnderecoSelecionado = (endereco: IEndereco) => {
    if (enderecosSelecionados.includes(endereco)) {
      setEnderecosSelecionados(R.filter((e) => e != endereco, enderecosSelecionados));
    } else {
      setEnderecosSelecionados(enderecosSelecionados.concat(endereco));
    }
  };

  const editarEndereco = (enderecoAEditar: IEndereco) => {
    const copiaDeEnderecosTemporarios = enderecosTemporarios?.map(i => i.Codigo == enderecoAEditar.Codigo ? enderecoAEditar : i)
    setEnderecosTemporarios(copiaDeEnderecosTemporarios);
  }

  const adicionarEndereco = (endereco: IEndereco) => {
    const copiaDeEnderecosTemporarios = Object.assign([], enderecosTemporarios)
    copiaDeEnderecosTemporarios.push({ ...endereco, Codigo: uuidv4() });
    setEnderecosTemporarios(copiaDeEnderecosTemporarios)
  }

  const excluirEnderecoTemporario = (enderecosSelecionados: IEndereco[]) => {
    const result = enderecosTemporarios.filter(e => !enderecosSelecionados.some(i => i.Codigo == e.Codigo))
    setEnderecosTemporarios(result);
  }

  const salvarTodosDados = async () => {
    const copiaDeEnderecosTemporarios = enderecosTemporarios?.map(i => ({ ...i, Codigo: 0 }))
    salvarClienteNaoCadastrado({ ...cliente, Enderecos: copiaDeEnderecosTemporarios })
    setExibirCadastrarCliente(true)
  }

  const ativaEditarEndereco = (ativa: boolean, endereco: IEndereco) => {
    setEnderecoAEditar(endereco);
    setExibeIncluirEndereco(ativa);
  };

  const manterDadosTemporariosDadosBasicos = (dadosTemporariosAtualizado: ICliente) => {
    setCliente(dadosTemporariosAtualizado);
  }

  const salvarClienteNaoCadastrado = async (cliente: any) => {
    try {
      globalMU.blockUI();
      const dadosPesquisados = await microuniversoApi.Orcamento.salvarClienteNaoCadastrado(
        identificadorOrcamento,
        cliente
      );
      if (!dadosPesquisados?.HasError) {
        store.dispatch(sobrescreverInformacoesAction({ NomeCliente: dadosPesquisados.Nome, ClienteNaoCadastrado: true }))
        globalMU.showSuccessMessage("Registro atualizado com sucesso");
      }
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const onLimpar = async () => {
    store.dispatch(sobrescreverInformacoesAction({
      ClienteNaoCadastrado: false
    }))

    await removerClienteOrcamento(orcamento.IdentificadorOrcamento);
    setCliente({})

    renderizarComponentReact(
      <PesquisarClienteContainer regiaoRenderizada={props.regiaoRenderizada} />,
      props.regiaoRenderizada,
      true
    );
  }


  useEffect(() => {
    atualizarParametros()
    cadastroClienteNaoCadastrado();
    atualizarPermissoes()
  }, []);

  return (

    <>
      {!exibeIncluirEndereco && (
        <>
          <Breadcrumb2Container
            passos={["Cliente Não Cadastrado"]}
            exibirBotaoLimpar={!orcamento.SomenteLeitura}
            exibirBotaoVoltar={false}
            id="AbaPesquisaClienteNaoCadastradoContainer"
            onBotaoLimparClicado={onLimpar}
          />

          <div className="_my-2 _border-b _border-solid _border-[#ddd] _shadow-[0_6px_rgb(0_0_0/3%)]">
            <Abas
              abas={[{ nome: "Dados Básicos" }, { nome: "Endereços" }]}
              id="AbasPesquisaClienteNaoCadastrado"
              nomeAbaSelecionada={abaSelecionada}
              onAbaSelecionada={(nome) => setAbaSelecionada(nome as NomesAbas)}
            />
          </div>

          {abaSelecionada == "Dados Básicos" && (
            <DadosBasicosClienteNaoCadastradoContainer
              somenteLeitura={orcamento.SomenteLeitura}
              permitirAlterarDadosBasicos={valorPermissaoPorAcao("ALTERAR") || valorPermissaoPorAcao("INCLUIR")}
              cliente={cliente}
              formularioValidado={formulariovalidado}
              onValidarFormulario={setValidarDadosBasicos}
              onErrorValidacao={setErrosFormulario}
              dadosBasicosClienteNaoCadastrado={cliente}
              manterDadosTemporariosCliente={manterDadosTemporariosDadosBasicos}
            />
          )}

          {abaSelecionada == "Endereços" && (
            <AbaEnderecosContainer
              somenteLeitura={orcamento.SomenteLeitura}
              tipoPessoa={cliente.TipoPessoa} // 441453
              habilitarExcluirEndereco={(valorPermissaoPorAcao("ALTERAR") || valorPermissaoPorAcao("INCLUIR")) && enderecosSelecionados.length > 0}
              permitirExcluirEndereco={valorPermissaoPorAcao("ENDERECO_CLIENTE_NAO_CADASTRADO_EXCLUIR")}
              permitirEditarEndereco={valorPermissaoPorAcao("ENDERECO_CLIENTE_NAO_CADASTRADO_ALTERAR")}
              permitirIncluirEndereco={valorPermissaoPorAcao("ENDERECO_CLIENTE_NAO_CADASTRADO_INCLUIR")}
              enderecosSelecionados={enderecosSelecionados}
              onToggleEnderecoSelecionado={onToggleEnderecoSelecionado}
              enderecos={enderecosTemporarios}
              ativarEditarEndereco={ativaEditarEndereco}
              excluirEnderecosTemporarios={excluirEnderecoTemporario}
            />
          )}
        </>
      )}

      {exibeIncluirEndereco && (
        <NovoEnderecoClienteContainer
          utilizarBairrosPreCadastrados={valorParametro("UTILIZAR_BAIRROS_PRE_CADASTRADOS") === "S"}
          numeroEBairroObrigatorio={valorParametro("BAIRRO_NUMERO_OPCIONAL_CADASTRO_CLIENTE") !== "S"}
          clienteNaoCadastrado={true}
          editarEndereco={editarEndereco}
          adicionarEndereco={adicionarEndereco}
          endereco={enderecoAEditar}
          cpfCnpj={cliente.CpfCnpj}
          ativaEditarEndereco={ativaEditarEndereco}
        />
      )}

      {(!exibeIncluirEndereco && (valorPermissaoPorAcao("ALTERAR") || valorPermissaoPorAcao("INCLUIR") || !orcamento.SomenteLeitura)) &&
        <>
          <button
            className={`no-global-button _mr-2 _mt-2 ${estilosBotoes.botaoPrimario}`}
            onClick={() => {
              validarDadosBasicos ? salvarTodosDados() : globalMU.showErrorMessage(errosFormulario)
              setFormularioValidado(true);
            }}
          >
            Aplicar
          </button>

          {((valorPermissaoPorAcao("INCLUIR") && exibirCadastrarCliente) || orcamento.ClienteNaoCadastrado) &&
            <button
              className={`no-global-button _mt-2 ${estilosBotoes.botaoPrimario}`}
              onClick={() => {
                renderizarComponentReact(
                  <AbasPesquisaClienteContainer regiaoRenderizada={props.regiaoRenderizada} />,
                  props.regiaoRenderizada,
                  true
                );
              }}
            >
              Cadastrar Cliente
            </button>
          }
        </>
      }

    </>
  );
};
